import TextClamp from "vue3-text-clamp";

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp;
  vueApp.component("TextClamp", TextClamp);
});
